import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-purple/15" data-id="element-373" data-mp="3b1chl3y5wofz">
    <div className="flex items-center mb-4" data-id="element-374" data-mp="36z94kavuhbsl">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-purple font-serif font-bold text-sm md:text-xl border border-brand-purple/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-375" data-mp="36wwgdfzhu573">
        {initials}
      </div>
      <div data-id="element-376" data-mp="2s308tjb5xgkx">
        <div className="flex text-brand-gold mb-1 text-[15px] md:text-lg" data-id="element-377" data-mp="2s39skp5m6ri6">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-378" data-mp="v8nbxaplulim" data-mpi={i} />)}
        </div>
        <div className="font-medium text-brand-text md:text-lg" data-id="element-379" data-mp="qbeqn195u1d5">{name}</div>
        <div className="text-xs md:text-sm text-brand-muted" data-id="element-380" data-mp="h5ezpnh15z1q">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] md:text-base font-serif leading-relaxed" data-id="element-381" data-mp="m6cgbvme6l14">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Ciudad de México, México',
    text: 'La enciclopedia A-Z es una herramienta que no existía en ningún lado. Por primera vez tengo un recurso con base científica real sobre plantas medicinales. Mis sesiones cambiaron completamente.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Bogotá, Colombia',
    text: 'El Volumen IV de seguridad clínica me salvó de cometer errores graves con pacientes medicados. La tabla de interacciones sola vale todo el kit.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'Lima, Perú',
    text: 'El Recetario Maestro con las 50 fórmulas es lo que más uso en consulta. Tengo respuesta concreta para cada cuadro. Mis pacientes sienten la diferencia desde la primera semana.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-382" data-mp="1oh2i4on8bieh">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px] md:text-sm" data-id="element-383" data-mp="1ofzs0ixqdjzm">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-384" data-mp="1jhpuw2sg49bd" data-mpi={i} />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Ciudad de México, México',
    product: 'Kit completo · 5 Volúmenes',
    text: 'La enciclopedia A-Z con el semáforo de seguridad me cambió la forma de prescribir. Ahora entro a cada consulta con certeza. Mis pacientes lo perciben desde el primer día.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Bogotá, Colombia',
    product: 'Terapeuta',
    text: 'La tabla de interacciones del Volumen IV debería ser obligatoria para cualquier terapeuta que trabaje con plantas. Evité un error grave con un paciente anticoagulado. Eso no tiene precio.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Lima, Perú',
    product: 'Estudiante avanzada',
    text: 'Recién empezaba y el kit me dio la estructura que necesitaba desde el primer paciente. No tuve que improvisar nada. El sistema hace el trabajo de años de experiencia.'
  }, {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Santiago, Chile',
    product: 'Médico naturista',
    text: 'El Volumen V de Alquimia Vegetal me abrió un camino que no imaginaba. La espagiria combinada con la fitococina terapéutica es un diferencial absoluto en mi práctica.'
  }, {
    initials: 'VP',
    name: 'Valentina P.',
    location: 'Montevideo, Uruguay',
    product: 'Naturópata',
    text: 'Las planillas del Legajo de Campo transformaron mi consultorio. Ahora cada paciente tiene un registro completo desde el primer día. Profesionalicé mi práctica en una semana.'
  }, {
    initials: 'RG',
    name: 'Roberto G.',
    location: 'Guadalajara, México',
    product: 'Herbolario',
    text: 'Lo que más me sorprendió fue la profundidad del Vademécum. 50 fórmulas listas para usar, con precauciones claras y tabla de sustituciones. Ya no improviso en consulta.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-385" data-mp="1qvq6u492dbql">
      <div className="text-center mb-12" data-id="element-386" data-mp="1quos9psua744">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-purpleDark pt-[0px]" data-id="element-387" data-mp="24mv7n9o64a2i">
          ❤️ MÁS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] md:text-sm max-w-4xl mx-auto" data-id="element-388" data-mp="1zqo2hj3lj2lm">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-389" data-mp="29m7sxpze592z" data-mpi={i} />)}
      </div>
    </Section>;
};